import { Component, OnInit } from '@angular/core';
import { ConnectionService } from '../../../shared/services/connections.service';
import { Adal4Service } from "adal-angular4";
import { Router, NavigationExtras } from "@angular/router";
import { Connection } from '../../../shared/classes/Connection';

@Component({
  selector: 'app-gerenciar-conexoes',
  templateUrl: './gerenciar-conexoes.component.html',
  styleUrls: ['./gerenciar-conexoes.component.css'],
  providers: [ConnectionService]
})
export class GerenciarConexoesComponent implements OnInit {
  
  listaConnections: Connection[] = []
  mostrarCarregando;
  indiceConexaoSelecionada: number = -1;
  conexaoSelecionada: Connection;
  temp_connectionName: string;
  temp_connString: string;
  isNewConnection: boolean = false;
  disableNewConnectionButton = false;
  msgAviso: string;
  class_fa_icon_ok = "fa fa-thumbs-o-up fa-3x text-success";
  class_fa_icon_nok = "fa fa-thumbs-o-down fa-3x text-error";
  class_icon_msg: string;
  canUserStorage: boolean = false;
  
  constructor(private _connectionsService: ConnectionService, private adalService: Adal4Service, private router: Router,) { }

  ngOnInit() {
    
    this.mostrarCarregando = true;
    this._connectionsService.getConnections()
    .then(connections => {        
      this.listaConnections = connections;
      this.mostrarCarregando = false;
      localStorage.setItem("conexoes", JSON.stringify(this.listaConnections));        
    }).catch(error => {
      this.mostrarCarregando = false;
      this.msgAviso = error.text();
      if(error.status == 403){
        alert("Você não tem permissão para acessar este recurso");
        this.router.navigate(['/home']); 
        return;
      }
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal3").click();
    });
        
  }

  disableFields(){
    if(this.listaConnections.length > 0){
     for (var index = 0; index < this.listaConnections.length; index++) {
       (<HTMLInputElement> document.getElementById("inputConnectionName"+index)).disabled = true; 
       (<HTMLInputElement> document.getElementById("inputConnString"+index)).disabled = true;   
     }
    }
  }

  editConnection(indexConnection: number){
    this.indiceConexaoSelecionada = indexConnection;
    this.temp_connectionName = this.listaConnections[indexConnection].connectionName;
    this.temp_connString = this.listaConnections[indexConnection].connString;
    (<HTMLInputElement> document.getElementById("inputConnectionName"+indexConnection)).disabled = false; 
    (<HTMLInputElement> document.getElementById("inputConnString"+indexConnection)).disabled = false; 
    (<HTMLInputElement> document.getElementById("btnSalvar")).disabled = false; 
    (<HTMLInputElement> document.getElementById("btnCancelar")).disabled = false;    
  }

  cancelAction(){    
    if(this.indiceConexaoSelecionada >= 0){
      if(!this.isNewConnection){
        var i = this.indiceConexaoSelecionada;
  
        this.listaConnections[i].connectionName = this.temp_connectionName;
        this.listaConnections[i].connString = this.temp_connString;
        
        (<HTMLInputElement> document.getElementById("inputConnectionName"+i)).disabled = true; 
        (<HTMLInputElement> document.getElementById("inputConnString"+i)).disabled = true; 
        
      }else{
        this.listaConnections.pop();
        this.isNewConnection = false;
        this.enableButtonNew();        
      }       
      this.disableSaveCancel();
    }
  }

  saveConnection(){
    if(this.indiceConexaoSelecionada >= 0){
      var i = this.indiceConexaoSelecionada;
      if(!this.isNewConnection){
        if(this.listaConnections[i].connectionName != this.temp_connectionName 
          || this.listaConnections[i].connString != this.temp_connString){        
          var editedConnection = this.listaConnections[this.indiceConexaoSelecionada];
          this._connectionsService.updateConnection(editedConnection.id, editedConnection).then(connection => {
            this.msgAviso = "Conexão editada com sucesso! -"+ editedConnection.connectionName;
            this.listaConnections[i] = connection;
            localStorage.setItem("conexoes", JSON.stringify(this.listaConnections));
            this.class_icon_msg = this.class_fa_icon_ok;
            document.getElementById("showMensagensModal3").click();
            this.disableFields();
            
          }).catch(error => {
            this.msgAviso = <any>error;
            this.class_icon_msg = this.class_fa_icon_nok;
            document.getElementById("showMensagensModal3").click();
          })
        }
      }else{
        var newConnection = this.listaConnections[i];
        if(newConnection.connectionName == null || newConnection.connectionName == ""){
            this.msgAviso = "Você precisa digitar um nome para a Conexão.";
            this.class_icon_msg = this.class_fa_icon_nok;
            document.getElementById("showMensagensModal3").click();
          return;
        }
        if(newConnection.connString == null || newConnection.connString == ""){
            this.msgAviso = "Você precisa a string de Conexão.";
            this.class_icon_msg = this.class_fa_icon_nok;
            document.getElementById("showMensagensModal3").click();
          return;
        }
        this._connectionsService.addConnection(newConnection).then(connection => {
          this.isNewConnection = false;
          this.listaConnections[this.indiceConexaoSelecionada] = connection;
          this.msgAviso = "Conexão criada com sucesso! - "+ connection.connectionName;
          localStorage.setItem("conexoes", JSON.stringify(this.listaConnections));
          
          this.disableSaveCancel();
          this.disableFields();
          this.class_icon_msg = this.class_fa_icon_ok;
          document.getElementById("showMensagensModal3").click();
        }).catch(error => {
          
          this.msgAviso = error.text() || <any>error;
          this.class_icon_msg = this.class_fa_icon_nok;
          document.getElementById("showMensagensModal3").click();
        })
      }
      this.enableButtonNew();
      
    }
  }
  addConnection(){
    (<HTMLInputElement> document.getElementById("btnSalvar")).disabled = false; 
    (<HTMLInputElement> document.getElementById("btnCancelar")).disabled = false;
    this.disableButtonNew();
     var newConnection: Connection = new Connection();
     
     this.listaConnections.push(newConnection);
     this.indiceConexaoSelecionada = this.listaConnections.length - 1;
     this.isNewConnection = true;
     this.enableSelectedConnectionFields(this.indiceConexaoSelecionada);
     
  }

  enableSelectedConnectionFields(i:number){
   // console.log("i: ", i);
    setTimeout(()=> {
      (<HTMLInputElement> document.getElementById("inputConnectionName"+i)).disabled = false; 
      (<HTMLInputElement> document.getElementById("inputConnString"+i)).disabled = false; 
    }, 200);    
  }

  deleteConnection(){
    if(this.indiceConexaoSelecionada < 0){return;}
    //console.log(this.grupoSelecionado);
    var connectionId = this.conexaoSelecionada.id;
    //console.log("groupId", groupId)
    this._connectionsService.deleteConnection(connectionId).then(() => {
      
      this.listaConnections.splice(this.indiceConexaoSelecionada, 1);  
      //console.log("lista apos splice", this.listaConnections);   
      this.msgAviso = "Conexão excluída com sucesso!";
      this.class_icon_msg = this.class_fa_icon_ok;
      document.getElementById("showMensagensModal3").click();
      localStorage.setItem("conexoes", JSON.stringify(this.listaConnections));
      //console.log("local storage apos splice", localStorage.getItem("conexoes"))
    }).catch(error => {
      this.msgAviso = error.text() || <any>error;
      this.class_icon_msg = this.class_fa_icon_nok;
      document.getElementById("showMensagensModal3").click();
    })
  }

  setIndexConnectionToDelete(i:number){
   // console.log("i do botão", i)
    this.indiceConexaoSelecionada = i;
    //console.log("[setIndexConnectionToDelete] this.indiceGrupoSelecionado",this.indiceGrupoSelecionado);
    this.conexaoSelecionada = this.listaConnections[this.indiceConexaoSelecionada];
  }

  disableSaveCancel(): any {
   (<HTMLInputElement> document.getElementById("btnSalvar")).disabled = true; 
   (<HTMLInputElement> document.getElementById("btnCancelar")).disabled = true;
  }

  disableButtonNew(){
    (<HTMLInputElement>document.getElementById("btnNewConnection")).disabled = true; 
  }
  enableButtonNew(){
    (<HTMLInputElement>document.getElementById("btnNewConnection")).disabled = false; 
  }
}



// WEBPACK FOOTER //
// C:/Users/ewerton.w.da.silva/Documents/Visual Studio 2017/Projects/SCL_Valia/SCL_Valia/src/app/paginas/relatorios/gerenciar-conexoes/gerenciar-conexoes.component.ts